export function readSystemInitialized(payload) {
  if (typeof payload?.initialized === 'boolean') {
    return payload.initialized;
  }

  if (typeof payload?.result?.initialized === 'boolean') {
    return payload.result.initialized;
  }

  return false;
}
